import App from './App';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css'; //core css
import 'primeicons/primeicons.css'; //icons
import 'primeflex/primeflex.css'; //flex
import 'react-toastify/dist/ReactToastify.css';
import './assets/styles/main.scss';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import data from './data/Translation.json';
import { createRoot } from 'react-dom/client';

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init(data);

const container = document.getElementById('recx-root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(<App />);
